import { render, staticRenderFns } from "./AssignPicking.vue?vue&type=template&id=89189f2a"
import script from "./AssignPicking.vue?vue&type=script&lang=js"
export * from "./AssignPicking.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports